import { ApolloProvider } from '@apollo/client'
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import { ThemeProvider as MUIThemeProvider } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { default as candidateTheme } from 'candidate/theme'
import { default as clientTheme } from 'client/theme'
import React, { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { default as recruiterTheme } from 'recruiter/theme'
import ToastProvider from 'shared/components/Toast/ToastProvider'
import client from 'shared/graphql/client'
import { NotificationProvider } from 'shared/hooks/useNotification'
import { UserRole } from 'shared/models/types/User'
import { router } from 'shared/routes'
import { useInitialsDateShortcut } from 'shared/hooks/useInitialsDateShortcut'
import 'shared/style/App.scss'
import { default as baseTheme } from 'shared/style/theme'
import { NotesProvider } from 'shared/utils/noteContext'
import { getSubdomain } from 'shared/utils/routing'

function App() {
    useInitialsDateShortcut()
    const subdomain = getSubdomain(process.env.REACT_APP_DOMAIN)
    const theme = (() => {
        switch (subdomain) {
            case UserRole.recruiter:
                return recruiterTheme
            case UserRole.client:
                return clientTheme
            case UserRole.candidate:
                return candidateTheme
            default:
                return baseTheme
        }
    })()

    return (
        <React.Fragment>
            <ApolloProvider client={client}>
                <NotificationProvider>
                    <NotesProvider>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MUIThemeProvider theme={theme}>
                                {/* E.W. TODO: Emotion ThemeProvider expects Partial<Theme> and we are providing a full Theme - I haven't figured out how to resolve the type error but it's type safe since we are providing a more strict type */}
                                <EmotionThemeProvider theme={theme as any}>
                                    <ToastProvider />
                                    <Suspense fallback={<CircularProgress />}>
                                        <RouterProvider router={router} />
                                    </Suspense>
                                </EmotionThemeProvider>
                            </MUIThemeProvider>
                        </LocalizationProvider>
                    </NotesProvider>
                </NotificationProvider>
            </ApolloProvider>
        </React.Fragment>
    )
}

export default App
